import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'

Vue.use(Router)
// /*  首页外添加路由格式
// {
//   path: '/statistics',
//   name: '/statistics',
//   component: statistics
// },*/ 
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js